module.exports = __webpack_public_path__ + "img/logo.5b13fac4.png";